import Grid from "@mui/material/Grid2";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";
import {
  AgreementsAutocomplete,
  PartnersAutocomplete,
} from "@shared/components/AutocompleteFields";

export function ReferralForm() {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 6 }}>
        <PartnersAutocomplete
          name="partner"
          label={translate("v1/partner_referral_admin.fields.partner")}
          required
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="company_name"
          label={translate("v1/partner_referral_admin.fields.company_name")}
          required
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="company_cnpj"
          label={translate("v1/partner_referral_admin.fields.company_cnpj")}
          mask="cnpj"
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="sales_value"
          label={translate("v1/partner_referral_admin.fields.sales_value")}
          mask="currency"
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="commission_percentage"
          label={translate("v1/partner_referral_admin.fields.commission_percentage")}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <AgreementsAutocomplete
          name="agreement"
          label={translate("v1/partner_referral_admin.fields.agreement")}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="notes"
          label={translate("v1/partner_referral_admin.fields.notes")}
        />
      </Grid>
    </Grid>
  );
}
